



// firebase.js
import { initializeApp } from "firebase/app";
import { getAuth } from "firebase/auth";
import { getFirestore } from "firebase/firestore";
import { getStorage } from "firebase/storage";

const firebaseConfig = {
apiKey: "AIzaSyBZpXPnbOYl1VvJSzCoeEPl7mw0pQWKAs8",
  authDomain: "peacekeeper-fa176.firebaseapp.com",
  databaseURL: "https://peacekeeper-fa176-default-rtdb.firebaseio.com",
  projectId: "peacekeeper-fa176",
  storageBucket: "peacekeeper-fa176.firebasestorage.app",
  messagingSenderId: "1045332526885",
  appId: "1:1045332526885:web:1b38065776a5abc6cabccc",
  measurementId: "G-28B30KEJJD"
};

// ✅ Initialize once
const app = initializeApp(firebaseConfig);

// Export services
export const auth = getAuth(app);
export const db = getFirestore(app);
export const storage = getStorage(app);
